import Vue from 'vue';
import Component from 'vue-class-component';
import * as ctpfront_pb from '@/../static/js/proto/CtpFront_pb';
import front from '@/../static/js/proto/CtpFront';
import * as ConditionData from '../../ConditionData';
import SelectButton from '../SelectButton/SelectButton.vue';

// tslint:disable-next-line:max-line-length
import TargetSelectedKeyboard from '../TargetSelectedKeyboard/TargetSelectedKeyboard.vue';
// tslint:disable-next-line:max-line-length
import TargetKeyboard from '@/views/components/TargetKeyboard/TargetKeyboard.vue';
import OrderPriceKeyboard from '../OrderPriceKeyboard/OrderPriceKeyboard.vue';
import * as utils from '@/utils/utils';
import { Property } from 'static/js/proto/Object_pb';
import { Prop, Watch } from 'vue-property-decorator';
/**
 * 新增条件单
 */
@Component({
  components: {
    SelectButton,
    TargetSelectedKeyboard,
    TargetKeyboard,
    OrderPriceKeyboard,
  },
})
export default class ConditionInsert extends Vue {
  @Prop()
  public targentId;
  @Prop()
  public type;
  @Prop()
  public closeOut;
  @Prop()
  public money;
  public newPrice: any = '';
  public latestPrice: string = '--';
  public oldTargetId: string = '';

  // 最小变动价
  public smallPrice: any = '';

  // 颜色变化
  public f_red = false;
  public f_green = false;
  public f_grey = true;

  public arrOperation = ConditionData.con_operation;
  public arrOffset = ConditionData.offset;
  public arrDirect = ConditionData.direct;
  public arrValidTime = ConditionData.validTime;

  public showTargetSelectedKeyboard = false;
  public showTargetKeyboard = false;
  public showPriceKeyboard = false;
  public showVolumeKeyboard = false;
  public showOrderPriceKeyboard = false;
  // 价格类型值
  public boardPrice: any = '';

  public formData = {
    operationType: front.con_operation_lt,
    price: '',
    offset: front.offset_open,
    direction: front.direct_buy,
    targetId: '',
    volume: '',
    validTime: front.con_validity_gfd,
    orderPrice: '',
    orderPriceType: front.con_limit_price,
  };

  public get orderPrice() {
    if (this.formData.orderPriceType === front.con_limit_price) {
      return this.formData.orderPrice;
    }
    return ConditionData.getText(
      ConditionData.con,
      this.formData.orderPriceType);
  }

  public priceValue = '';

  public checkedOperationNum = -1;

  @Watch('newPrice', { deep: true })
  public latestPrices(tick, old) {
    if (tick.latestPrice === tick.lastSettlementPrice) {
      this.f_red = false;
      this.f_green = false;
      this.f_grey = true;
    } else if (tick.latestPrice > tick.lastSettlementPrice) {
      this.f_red = true;
      this.f_green = false;
      this.f_grey = false;
    } else if (tick.latestPrice < tick.lastSettlementPrice) {
      this.f_red = false;
      this.f_green = true;
      this.f_grey = false;
    }
    this.$store.commit('priceTick/changePriceT', tick.priceTick);
    this.latestPrice = tick.latestPrice;
    this.smallPrice = Number((tick.priceTick * 10000).toFixed(0)) / 10000;
    this.changeBoardPrice();
  }
  @Watch('formData.orderPriceType', { deep: true })
  public changePriceType(news, old) {
    this.changeBoardPrice();
  }
  @Watch('formData.direction', { deep: true })
  public changeDirection(news, old) {
    this.changeBoardPrice();
  }
  public changeBoardPrice() {
    // console.log(this.formData.orderPriceType);
    this.boardPrice = 0;
    if (!this.newPrice) {
      return;
    }
    if (this.formData.direction === 1) {
      switch (this.formData.orderPriceType) {
        case 16:           // 对手价
          this.boardPrice =
            this.newPrice.askPrice1 ? this.newPrice.askPrice1 : 0;
          break;
        case 4:            // 最新价
          this.boardPrice =
            this.newPrice.latestPrice ? this.newPrice.latestPrice : 0;
          break;
        case 17:           // 市价
          this.boardPrice =
            this.newPrice.highStopPrice ? this.newPrice.highStopPrice : 0;
          break;
        case 18:           // 超价
          this.boardPrice =
            this.newPrice.bidPrice1 ? this.newPrice.bidPrice1 : 0;
          break;
      }
    } else if (this.formData.direction === 2) {
      switch (this.formData.orderPriceType) {
        case 16:           // 对手价
          this.boardPrice =
            this.newPrice.bidPrice1 ? this.newPrice.bidPrice1 : 0;
          break;
        case 4:            // 最新价
          this.boardPrice =
            this.newPrice.latestPrice ? this.newPrice.latestPrice : 0;
          break;
        case 17:           // 市价
          this.boardPrice =
            this.newPrice.lowStopPrice ? this.newPrice.lowStopPrice : 0;
          break;
        case 18:           // 超价
          this.boardPrice =
            this.newPrice.askPrice1 ? this.newPrice.askPrice1 : 0;
          break;
      }
    }
  }

  public mounted() {
    this.setDefault();
  }
  public deactivated() {
    this.formData.orderPrice = '';
    this.newPrice = '';
    front.unsubTick(this.targentId, 'conditionInsert');
    this.latestPrice = '--';
  }
  public activated() {
    this.formData.targetId = this.targentId;
    // console.log(this.type);
    // console.log(this.closeOut);
    if (this.type === '买') {
      this.formData.direction = 2;
    } else {
      this.formData.direction = 1;
    }
    if (this.$route.query.Num) {
      this.formData.offset = 2;
    } else {
      this.formData.offset = 1;
    }
    this.formData.volume = this.closeOut;
    this.formData.price = this.money;
    this.getLatestPrice();
  }
  public setDefault() {
    this.formData = {
      operationType: front.con_operation_lt,
      price: '',
      offset: front.offset_open,
      direction: front.direct_buy,
      targetId: '',
      volume: '',
      validTime: front.con_validity_gfd,
      orderPrice: '',
      orderPriceType: front.con_opponent_price,
    };
  }
  // 增加条件单
  public addCondition() {
    const cond = new ctpfront_pb.OrderConditional();
    const data = this.formData;

    if (!this.formData.targetId) {
      utils.toast('请选择合约');
      return;
    }
    if (!this.formData.price) {
      utils.toast('请输入价格');
      return;
    }
    if (!this.formData.volume) {
      utils.toast('请输入手数');
      return;
    }
    if (this.formData.orderPriceType === front.con_limit_price
      && utils.isZero(this.formData.orderPrice)) {
      utils.toast('请输入报单价');
      return;
    }
    if (this.formData.orderPriceType === 2 &&
      ((Number(this.formData.orderPrice) * 1000000) as any).toFixed(0) %
      ((this.smallPrice * 1000000) as any).toFixed(0) !== 0) {
      utils.toast('下单价格不符合该合约的最小变动价位');
      return;
    }
    if (((Number(this.formData.price) * 1000000) as any).toFixed(0) %
    ((this.smallPrice * 1000000) as any).toFixed(0) !== 0) {
      utils.toast('下单价格不符合该合约的最小变动价位');
      return;
    }
    cond.setTargetId(data.targetId);
    cond.setPrice(data.price);
    cond.setConditionPriceType(front.con_last_price);
    cond.setOperationType(data.operationType);
    cond.setVolume(data.volume);
    cond.setDirection(data.direction);
    cond.setOffset(data.offset);
    cond.setValidTime(data.validTime);
    cond.setState(0);
    cond.setOrderPrice(data.orderPrice);
    cond.setOrderPriceType(data.orderPriceType);
    // cond.setStateDetail("状态详情");
    // cond.setAccount("xuefeng");
    utils.indicator('正在处理...');
    front.conditionOrderSave(cond, resolve => {
      utils.closeIndicator();
      utils.toast('添加成功');
      // this.setDefault();
      console.log(resolve);
    }, reject => {
      console.error(reject);
      utils.toast('失败: ' + reject.message);
      utils.closeIndicator();
    });

  }
  public handleCancel() {
    this.setDefault();
  }

  // 键盘选择合约时触发事件
  public choiceTargetId(targetId) {
    if (this.oldTargetId) {
      front.unsubTick(this.oldTargetId, 'conditionInsert');
      this.latestPrice = '--';
    }
    this.setDefault();
    this.formData.targetId = targetId;
    this.oldTargetId = targetId;
    this.newPrice = front.subTick(targetId, 'conditionInsert');
  }

  // 最新价
  public getLatestPrice() {
    if (this.targentId) {
      this.oldTargetId = this.targentId;
      this.newPrice = front.subTick(this.targentId, 'conditionInsert');
    } else {
      this.latestPrice = '--';
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/condition/components/ConditionInsert/ConditionInsert.ts